module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gb-Hc-Ic-Jb.8abec497.png";